import { render } from "./AvatarConversation.vue?vue&type=template&id=009e74fc&scoped=true&ts=true"
import script from "./AvatarConversation.vue?vue&type=script&lang=ts"
export * from "./AvatarConversation.vue?vue&type=script&lang=ts"

import "./AvatarConversation.vue?vue&type=style&index=0&id=009e74fc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009e74fc"]])

export default __exports__